/**
 * Specifies the market scope of the market data.
 * tag: 546
 * @readonly
 * @enum {string} (MultipleCharValue)
 */
export enum Scope {
  /** Local Market (Exchange, ECN, ATS) */
  LocalMarket = '1',
  /** National */
  National = '2',
  /** Global */
  Global = '3',
}
